import { render, staticRenderFns } from "./ChatSummaryModal.vue?vue&type=template&id=36680509&scoped=true&"
import script from "./ChatSummaryModal.vue?vue&type=script&lang=js&"
export * from "./ChatSummaryModal.vue?vue&type=script&lang=js&"
import style0 from "./ChatSummaryModal.vue?vue&type=style&index=0&id=36680509&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36680509",
  null
  
)

export default component.exports